import { RadioGroup, RadioGroupItem } from "./ui/radio-group";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

export const PaymentPreference = ({ methods, value, onChange, handle, onHandle }) => {
  if (!methods.length) {
    return (
      <p className="text-sm text-[#5E4D5A] leading-relaxed" data-testid="payment-pref-none">
        After you submit, our team will contact you by email with payment instructions.
      </p>
    );
  }
  const chosen = methods.find((m) => m.key === value);
  return (
    <div className="space-y-4">
    <RadioGroup value={value} onValueChange={onChange} className="space-y-3" data-testid="payment-pref-group">
      {methods.map((m) => (
        <label key={m.key} className="flex items-start gap-3 cursor-pointer rounded-xl border border-[#A8B59A]/30 p-4 hover:bg-[#F4EBDD] transition-colors">
          <RadioGroupItem value={m.key} id={`pm-${m.key}`} data-testid={`payment-pref-${m.key}`} className="mt-0.5" />
          <div>
            <Label htmlFor={`pm-${m.key}`} className="text-[15px] cursor-pointer">{m.label}</Label>
            {m.instructions && <p className="text-xs text-[#5E4D5A] mt-1">{m.instructions}</p>}
          </div>
        </label>
      ))}
    </RadioGroup>
    {chosen && chosen.needs_handle && (
      <div>
        <Label htmlFor="pm-handle">Your {chosen.label} email or username</Label>
        <Input id="pm-handle" maxLength={100} value={handle} onChange={(e) => onHandle(e.target.value)} className="mt-2 rounded-xl" data-testid="payment-handle" />
        <p className="text-xs text-[#5E4D5A] mt-1">We'll use this to send you a payment request. Nothing is charged automatically.</p>
      </div>
    )}
    </div>
  );
};
